import { CapoPlugin } from "/Users/olivermurphy/Code/spas/justhire/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];